import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService } from '../../shared/http.service';
import { IReportSum } from './report-sum';
import { IReportOrder } from './report-order';
import { IPeilutDdl } from './peilut-ddl';
import { ITatPeilutDdl } from './tat-peilut-ddl';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../../shared/app-settings'
import { ConfigService } from 'app/shared/config.service';

@Injectable()
export class ReportService {

    private _reportUrl = `${this.apiUrl}/api/Report`;
    private _peilutDdlUrl = `${this.apiUrl}/api/Peilut/GetPeilutDdl`;
    private _tatPeilutDdlUrl = `${this.apiUrl}/api/Peilut/GetTatPeilutDdl`;
    apiUrl: string = "";
    constructor(private _http: HttpService,private _configService: ConfigService)
     {
         this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
      }

    getReportSum(): Observable<IReportSum[]> {
        return this._http.get(this._reportUrl)
            .map((response: Response) => <IReportSum[]>response.json())
            .catch(this.handleError);
    }

    getReportOrders(): Observable<IReportOrder[]> {
        return this._http.get(this._reportUrl + '/OrdersReport')
            .map((response: Response) => <IReportOrder[]>response.json())
            .catch(this.handleError);
    }

    getPeilutDdl(): Observable<IPeilutDdl[]> {
        return this._http.get(this._peilutDdlUrl)
            .map((res: Response) => <IPeilutDdl[]>res.json())
            .catch(this.handleError);
    }

    getTatPeilutDdl(): Observable<ITatPeilutDdl[]> {

        return this._http.get(this._tatPeilutDdlUrl)
            .map((res: Response) => <ITatPeilutDdl[]>res.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);

            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        //console.error(errMsg);
        return Observable.throw(errMsg);
    }
}